module.exports = __webpack_public_path__ + "static/tiamat-symbol-ROT-794978b88eca8881f982d5fb031b9554.png";